"use client";

// src/callout.tsx
import { cn } from "@momo/utils";
import { AlertOctagonIcon, AlertTriangleIcon, InfoIcon } from "lucide-react";
import { jsx, jsxs } from "react/jsx-runtime";
var Callout = (props) => {
  const { title, type = "info", icon, className, children, ...rest } = props;
  const icons = {
    info: /* @__PURE__ */ jsx(InfoIcon, { className: "my-0.5 size-4 text-blue-500" }),
    warning: /* @__PURE__ */ jsx(AlertTriangleIcon, { className: "my-0.5 size-4 text-orange-500" }),
    error: /* @__PURE__ */ jsx(AlertOctagonIcon, { className: "my-0.5 size-4 text-red-500" })
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "bg-card text-muted-foreground my-6 flex w-full flex-row gap-2 rounded-lg border p-3 text-sm shadow-md",
        className
      ),
      ...rest,
      children: [
        icon ?? icons[type],
        /* @__PURE__ */ jsxs("div", { className: "w-0 flex-1", children: [
          title ? /* @__PURE__ */ jsx("div", { className: "text-card-foreground mb-2 font-medium", children: title }) : null,
          /* @__PURE__ */ jsx("div", { children })
        ] })
      ]
    }
  );
};

export {
  Callout
};
